import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import userApi from 'services/api/user'

import styles from './SubmitConfirmationDialog.module.scss'

// charges
// charge.chargeKind
// charge.description
// charge.amount

const SubmitConfirmationDialog = ({
  onClose,
  onConfirm,
  totalAmount,
  chargeCount,
  isLoading,
  charges
}) => {
  const { addToast } = useToasts()
  const [invoiceRecipients, setInvoiceRecipients] = useState([])
  const [isLoadingRecipients, setIsLoadingRecipients] = useState(false)

  useEffect(() => {
    setIsLoadingRecipients(true)
    userApi
      .getList()
      .then(data => {
        if (data && data.users) {
          const recipients = data.users
            .filter(user => user.isInvoiceRecipient)
            .map(user => user.email)
          setInvoiceRecipients(recipients)
        }
      })
      .catch(() => {
        addToast('Failed to get invoice recipients.', { appearance: 'error' })
      })

      .finally(() => {
        setIsLoadingRecipients(false)
      })
  }, [addToast])

  return (
    <ConfirmationDialog
      title="Custom Charge Submission"
      positiveMessage={isLoading ? 'Submitting...' : 'Create invoice'}
      negativeMessage="Cancel"
      onClose={onClose}
      onConfirm={onConfirm}
      hasDangerousAction
      isButtonDisabled={isLoading}
      theme="blacklist"
    >
      {isLoadingRecipients ? (
        <LoadingIndicator inline />
      ) : (
        <div className={styles.content}>
          <div className={styles.charges}>
            {charges.map((charge, index) => (
              <div key={index} className={styles.chargeItem}>
                <div className={styles.chargeFields}>
                  <div className={styles.field}>
                    <div className={styles.label}>Category</div>
                    <div className={styles.value}>{charge.chargeKind}</div>
                  </div>
                  <div className={styles.field}>
                    <div className={styles.label}>Description</div>
                    <div className={styles.value}>{charge.description}</div>
                  </div>
                  <div className={styles.field}>
                    <div className={styles.label}>Amount</div>
                    <div className={styles.value}>
                      {parseFloat(charge.amount).toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD'
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <p>
            You're about to submit {chargeCount} custom charge
            {chargeCount > 1 ? 's' : ''} for a total of{' '}
            <span className={styles.bold}>
              {totalAmount.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              })}
            </span>
            .
          </p>

          {invoiceRecipients.length > 0 && (
            <div className={styles.recipientList}>
              <p>
                This will also{' '}
                <span className={styles.bold}>
                  create new invoice
                  {invoiceRecipients.length > 1 ? 's' : ''}
                </span>
                .
              </p>
              <p>
                The following user{invoiceRecipients.length > 1 ? 's' : ''} will get an
                email notification:
              </p>
              <div className={styles.emailList}>
                {invoiceRecipients.map(email => (
                  <p key={email} className={styles.emailItem}>
                    {email}
                  </p>
                ))}
              </div>
            </div>
          )}

          <p>Do you want to continue?</p>
        </div>
      )}
    </ConfirmationDialog>
  )
}

export default SubmitConfirmationDialog
